var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"e-chat__item",class:{
    'e-chat__item--opponent': _vm.type !== 'user',
    'e-chat__item--user': _vm.type === 'user'
  }},[_c('div',{staticClass:"e-chat__item-aside"},[_c('div',{staticClass:"e-chat__avatar"},[_c('icon-user',{attrs:{"aria-label":_vm.$t(
            _vm.type === 'user' ? 'aria.chatAvatarMe' : 'aria.chatAvatarOpponent'
          )}})],1)]),_c('div',{staticClass:"e-chat__item-content"},[_vm._l((_vm.messages),function(msg,index){return [_c('chat-message',{key:index,attrs:{"message":msg,"deletable":_vm.type === 'user' && !msg.deleted && !_vm.readOnly}})]})],2)])}
var staticRenderFns = []

export { render, staticRenderFns }